// extracted by mini-css-extract-plugin
export var box = "OfferUrgencyBox-module--box--40e27";
export var closeButton = "OfferUrgencyBox-module--close-button--35ccc";
export var content = "OfferUrgencyBox-module--content--96262";
export var countdown = "OfferUrgencyBox-module--countdown--afe6d";
export var cta = "OfferUrgencyBox-module--cta--095ab";
export var fadeInRight = "OfferUrgencyBox-module--fadeInRight--aee9c";
export var footer = "OfferUrgencyBox-module--footer--b64a6";
export var icon = "OfferUrgencyBox-module--icon--59592";
export var iconWrapper = "OfferUrgencyBox-module--icon-wrapper--3050e";
export var title = "OfferUrgencyBox-module--title--8477d";
export var wrapper = "OfferUrgencyBox-module--wrapper--23a5d";